import {
  useInitializeFirebaseAuth,
  useReloadFirebaseAuth,
} from "hooks/useFirebaseAuth"
import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useRecoilValue } from "recoil"
import { firebaseUserState } from "recoils/firebaseUserState"

interface AuthorizedOnlyPropsIF {
  children: React.ReactNode
  emailVerifiedRequired?: boolean
}

export const AuthorizedOnly = ({
  children,
  emailVerifiedRequired = true,
}: AuthorizedOnlyPropsIF) => {
  const user = useInitializeFirebaseAuth()
  const navigate = useNavigate()

  const navigateOutside = () => {
    if (!user.isFirebaseInitialized) return

    if (!user.isAuth) {
      navigate("/login")
      return
    }

    if (user.isAuth && !user.emailVerified && emailVerifiedRequired) {
      navigate("/register/mail")
    }
  }

  useEffect(() => {
    navigateOutside()
  }, [user])

  return <div>{user.isFirebaseInitialized && user.isAuth ? children : ""}</div>
}

export const AuthorizedRegisterEmail = ({
  children,
}: AuthorizedOnlyPropsIF) => {
  const user = useRecoilValue(firebaseUserState)
  const reloadUser = useReloadFirebaseAuth()
  const navigate = useNavigate()

  const navigateOutside = () => {
    if (user.isFirebaseInitialized && user.isAuth && user.emailVerified) {
      navigate("/")
      return
    }

    if (user.isFirebaseInitialized && !user.isAuth) {
      navigate("/login")
    }
  }

  useEffect(() => {
    navigateOutside()
    if (user.emailVerified) return
    const timerId = setInterval(() => reloadUser().then(navigateOutside), 5000)
    return () => {
      clearInterval(timerId)
    }
  }, [user])

  return (
    <AuthorizedOnly emailVerifiedRequired={false}>{children}</AuthorizedOnly>
  )
}
